export default function DisabledIndicatorPanel({ icon, title, message }) {
  return (
    <div
      aria-disabled="true"
      className="w-full px-4 mb-4 rounded border border-slate-200 bg-slate-50 shadow-sm opacity-75"
    >
      <div className="min-h-[74px] w-full flex flex-col gap-3 py-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center">
          <img className="h-[50px] w-[50px] grayscale" src={icon} alt="" />
          <div className="ml-3">
            <p className="text-[18px] text-slate-500">{title}</p>
            <p className="mt-1 text-sm text-slate-500">{message}</p>
          </div>
        </div>
        <span className="inline-flex w-fit items-center rounded border border-slate-300 bg-white px-3 py-1 text-xs font-semibold uppercase text-slate-500">
          Disabled
        </span>
      </div>
    </div>
  );
}
